module.exports = __webpack_public_path__ + "img/spezialisierungen_1920.8d09b024.webp";